import React, { Component } from 'react';
import { connect } from 'react-redux';
import logo from './logo.svg';
import './App.css';
import 'antd/dist/antd.css';
import { Layout, Menu, Breadcrumb, Icon, Popover, Button, Badge} from 'antd';
import { BrowserRouter as Router, Route, Link, Redirect, Switch } from 'react-router-dom';
import Employee from './components/Employee/Employee';
import EmployeeDetail from './components/Employee/EmployeeDetail';
import EmployeeCreate from './components/Employee/EmployeeCreate';
import CostCenter from './components/CostCenter/CostCenter';
import Country from './components/Country/Country';
import Education from './components/Education/Education';
import EmploymentStatus from './components/EmploymentStatus/EmploymentStatus';
import Ethnicity from './components/Ethnicity/Ethnicity';
import JobCategory from './components/JobCategory/JobCategory';
import JobTitle from './components/JobTitle/JobTitle';
import Language from './components/Language/Language';
import License from './components/License/License';
import Location from './components/Location/Location';
import Membership from './components/Membership/Membership';
import Nationality from './components/Nationality/Nationality';
import PayGrade from './components/PayGrade/PayGrade';
import Skill from './components/Skill/Skill';
import SubUnit from './components/SubUnit/SubUnit';
import User from './components/User/User';
import PasswordReset from './components/User/PasswordReset';
import WorkShift from './components/WorkShift/WorkShift';
import LeaveType from './components/LeaveType/LeaveType';
import LeaveRequest from './components/LeaveRequest/LeaveRequest';
import MyLeaveRequest from './components/LeaveRequest/MyLeaveRequest';
import LeaveRequestsForApproval from './components/LeaveRequest/LeaveRequestsForApproval';
import LeavePolicy from './components/LeavePolicy/LeavePolicy';
import LeaveBalance from './components/LeaveBalance/LeaveBalance';
import MyLeaveBalance from './components/LeaveBalance/MyLeaveBalance';
import Department from './components/Department/Department';
import Division from './components/Division/Division';
import Group from './components/Group/Group';
import Permission from './components/Permission/Permission';
import Dashboard from './containers/Dashboard';
import LeaveCalendar from './containers/LeaveCalendar';
import axios from 'axios';


import { Row, Col } from 'antd';
import * as actions from './store/actions/auth';
import Login from './containers/Login'
import Signup from './containers/Signup';
import Holiday from './components/Holiday/Holiday';

const {
  Header, Content, Footer, Sider,
} = Layout;
const SubMenu = Menu.SubMenu;

const API_HOST_URL = process.env.REACT_APP_API_URL

class App extends Component {

  componentDidMount(){
    this.props.onTryAutoSignup();
    console.log(this.props.currentUser);
    this.leaveRequestsForApproval();
    console.log("array size: ", this.state.leaveRequestsForApproval.length)
  }

  state = {
    collapsed: false,
    leaveRequestsForApproval: []
  }

  onCollapse = (collapsed) => {
    console.log(collapsed);
    this.setState({ collapsed });
  }

  changeHeaderTitle(title){
    this.props.changeHeaderTitle(title);
  }

  leaveRequestsForApproval = () => {
    axios.get(`${API_HOST_URL}/api/leave/leaverequest/?expand=employee&expand=leaveType&approver=${this.props.loggedInEmployee.id}`)
      .then(res => {
        this.setState({
          leaveRequestsForApproval: res.data
        })
      })
  }

  render() {
    const content = (
      <div>
        <Link to="/leaverequests-for-approval">Leave Requests to Approve<Badge count={5} /></Link>
      </div>
    );
    return (
      <Router>
      <Layout style={{ minHeight: '100vh' }}>
{
  this.props.isAuthenticated ?
  <Sider
        width="240"
        collapsible
        collapsed={this.state.collapsed}
        onCollapse={this.onCollapse}
        breakpoint="lg"
        collapsedWidth="0"
    >
          <div className="logo" >
           <h2 style={{color: "white", margin: "12px"}}>TIA Hr</h2>
          </div>
          <Menu theme="dark" defaultSelectedKeys={['1']} mode="inline">
            <Menu.Item key="1">
              <Link to="/" onClick={()=>this.changeHeaderTitle('Dashboard')}>
                <Icon type="desktop" />
                Dashboard
              </Link>
            </Menu.Item>
            <Menu.Item key="sub1-10">
                  <Link to="/password-reset" onClick={()=>this.changeHeaderTitle('Reset Your Password')}>Reset Your Password</Link>
            </Menu.Item>
            {
              this.props.userContentTypes.indexOf('systemsetup') > -1 ?
            <SubMenu
              key="sub1"
              title={<span><Icon type="setting" /><span>Administration</span></span>}
            >
            

            {
              this.props.userContentTypes.indexOf('auth') > -1 ? 
            <SubMenu
              key="sub1-11"
              title={<span>User Management</span>}
            >
              <Menu.Item key="sub1-11-1">
                  <Link to="/user" onClick={()=>this.changeHeaderTitle('Users')}>Users</Link>
              </Menu.Item>
            
              <Menu.Item key="sub1-11-2">
                 <Link to="/user-roles" onClick={()=>this.changeHeaderTitle('User Roles')}>User Roles</Link>
              </Menu.Item>
              <Menu.Item key="sub1-11-3">
                  <Link to="/user-permissions" onClick={()=>this.changeHeaderTitle('User Permissions')}>Permissions</Link>
              </Menu.Item>
            </SubMenu>
            : ''
          }
            <SubMenu
              key="sub1-1"
              title={<span>Job</span>}
            >
            {
              this.props.userPermissions.indexOf('view_jobtitle') > -1 ? 
              <Menu.Item key="sub1-1-1">
                  <Link to="/jobtitle" onClick={()=>this.changeHeaderTitle('JobTitles')}>Job Titles</Link>
              </Menu.Item>
              : ''
            }

              {
              this.props.userPermissions.indexOf('view_paygrade') > -1 ? 
              <Menu.Item key="sub1-1-2">
                 <Link to="/paygrade" onClick={()=>this.changeHeaderTitle('Pay Grades')}>Pay Grades</Link>
              </Menu.Item>
              : ''
              }

              {
              this.props.userPermissions.indexOf('view_employmentstatus') > -1 ? 
              <Menu.Item key="sub1-1-3">
                  <Link to="/employmentstatus" onClick={()=>this.changeHeaderTitle('Employment Statuses')}>Employment Status</Link>
              </Menu.Item>
              : ''
              }

              {
              this.props.userPermissions.indexOf('view_jobcategory') > -1 ? 
              <Menu.Item key="sub1-1-4">
                  <Link to="/jobcategory" onClick={()=>this.changeHeaderTitle('Job Categories')}>Job Categories</Link>
              </Menu.Item>
              : ''
              }

              {
              this.props.userPermissions.indexOf('view_workshift') > -1 ? 
              <Menu.Item key="sub1-1-5">
                  <Link to="/workshift" onClick={()=>this.changeHeaderTitle('Work Shifts')}>Work Shifts</Link>
              </Menu.Item>
              : ''
              }
            </SubMenu>
            <SubMenu
              key="sub1-2"
              title={<span>Organisation</span>}
            >

            {
              this.props.userPermissions.indexOf('view_holiday') > -1 ? 
              <Menu.Item key="sub1-2-0">
                  <Link to="/holiday" onClick={()=>this.changeHeaderTitle('Holidays')}>Holidays</Link>
              </Menu.Item>
              : ''
            }

            {
              this.props.userPermissions.indexOf('view_location') > -1 ? 
              <Menu.Item key="sub1-2-1">
                  <Link to="/location" onClick={()=>this.changeHeaderTitle('Locations')}>Locations</Link>
              </Menu.Item>
              : ''
            }

              {
              this.props.userPermissions.indexOf('view_costcenter') > -1 ? 
              <Menu.Item key="sub1-2-2">
                  <Link to="/costcenter" onClick={()=>this.changeHeaderTitle('Cost Centers')}>Cost Centers</Link>
              </Menu.Item>
              : ''
              }

              {
              this.props.userPermissions.indexOf('view_subunit') > -1 ? 
              <Menu.Item key="sub1-2-3">
                  <Link to="/subunit" onClick={()=>this.changeHeaderTitle('Sub Units')}>Sub Units</Link>
              </Menu.Item>
              : ''
              }

              {
              this.props.userPermissions.indexOf('view_country') > -1 ? 
              <Menu.Item key="sub1-2-4">
                <Link to="/country" onClick={()=>this.changeHeaderTitle('Countries')}>Countries</Link>
              </Menu.Item>
              : ''
              }

              {
              this.props.userPermissions.indexOf('view_nationality') > -1 ? 
              <Menu.Item key="sub1-2-5">
                  <Link to="/nationality" onClick={()=>this.changeHeaderTitle('Nationalities')}>Nationalities</Link>
              </Menu.Item>
              : ''
              }

              {
              this.props.userPermissions.indexOf('view_ethnicity') > -1 ? 
              <Menu.Item key="sub1-2-6">
                  <Link to="/ethnicity" onClick={()=>this.changeHeaderTitle('Ethnicities')}>Ethnicities</Link>
              </Menu.Item>
              : ''
              }

              {
              this.props.userPermissions.indexOf('view_department') > -1 ? 
              <Menu.Item key="sub1-2-7">
                  <Link to="/department" onClick={()=>this.changeHeaderTitle('Departments')}>Department</Link>
              </Menu.Item>
              : ''
              }

              {
              this.props.userPermissions.indexOf('view_division') > -1 ? 
              <Menu.Item key="sub1-2-8">
                  <Link to="/division" onClick={()=>this.changeHeaderTitle('Divisions')}>Division</Link>
              </Menu.Item>
              : ''
              }
            </SubMenu>
            <SubMenu
              key="sub1-3"
              title={<span>Qualifications</span>}
            >

            {
              this.props.userPermissions.indexOf('view_skill') > -1 ? 
              <Menu.Item key="sub1-3-1">
                  <Link to="/skill" onClick={()=>this.changeHeaderTitle('Skills')}>Skills</Link>
              </Menu.Item>
              : ''
            }

              {
              this.props.userPermissions.indexOf('view_education') > -1 ? 
              <Menu.Item key="sub1-3-2">
                <Link to="/education" onClick={()=>this.changeHeaderTitle('Education Levels')}>Education</Link>
              </Menu.Item>
              : ''
              }

              {
              this.props.userPermissions.indexOf('view_license') > -1 ? 
              <Menu.Item key="sub1-3-3">
                 <Link to="/license" onClick={()=>this.changeHeaderTitle('Licenses')}>Licenses</Link>
              </Menu.Item>
              : ''
              }

              {
              this.props.userPermissions.indexOf('view_language') > -1 ? 
              <Menu.Item key="sub1-3-4">
                  <Link to="/language" onClick={()=>this.changeHeaderTitle('Languages')}>Languages</Link>
              </Menu.Item>
              : ''
              }

              {
              this.props.userPermissions.indexOf('view_membership') > -1 ? 
              <Menu.Item key="sub1-3-5">
                  <Link to="/membership" onClick={()=>this.changeHeaderTitle('Memberships')}>Memberships</Link>
              </Menu.Item>
              :''
              }
            </SubMenu>
            </SubMenu>
            : ''
            }

            {
              this.props.userContentTypes.indexOf('employee') > -1 ?
            <SubMenu
              key="sub2"
              title={<span><Icon type="team" /><span>Personnel</span></span>}
            >
            {
              this.props.userPermissions.indexOf('view_employee') > -1 ? 
              <Menu.Item key="sub2-1">
                  <Link to="/employee" onClick={()=>this.changeHeaderTitle('Employees')}>Employees</Link>
              </Menu.Item>
              : ''
            }
            {
              this.props.userPermissions.indexOf('add_employee') > -1 ? 
              <Menu.Item key="sub2-2">
                  <Link to="/employee/new" onClick={()=>this.changeHeaderTitle('Add New Employee')}>Add Employee</Link>
              </Menu.Item>
              : ''
            }
            </SubMenu>
            : ''
           }

           {
              this.props.userContentTypes.indexOf('leave') > -1 ?
            <SubMenu
              key="sub3"
              title={<span><Icon type="schedule" /><span>Leave</span></span>}>

              {
              this.props.userPermissions.indexOf('access_my_leave') > -1 ?
              <Menu.Item key="sub3-1">
                  <Link to="/myleaverequest" onClick={()=>this.changeHeaderTitle('My Leave Requests')}>My Leave</Link>
              </Menu.Item>
              : ''
              }
              
              {
              this.props.userPermissions.indexOf('approve_leave') > -1 ?  
              <Menu.Item key="sub3-2">
                  <Link to="/leaverequests-for-approval" onClick={()=>this.changeHeaderTitle('Leave Requests for My Approval')}>Leave Requests for Approval</Link>
              </Menu.Item>
              : ''
              }

              {
                this.props.userPermissions.indexOf('view_leaverequest') > -1 ? 
                <Menu.Item key="sub3-3">
                    <Link to="/leaverequest" onClick={()=>this.changeHeaderTitle('All Leave Requests')}>All Leave Requests</Link>
                </Menu.Item>
                : ''
              }

              {
                this.props.userPermissions.indexOf('view_leavebalance') > -1 ? 
                <Menu.Item key="sub3-4">
                    <Link to="/leavebalance" onClick={()=>this.changeHeaderTitle('Leave Balance')}>All Leave Balances</Link>
                </Menu.Item>
                : ''
              }

              {
              this.props.userPermissions.indexOf('access_my_leavebalance') > -1 ?
              <Menu.Item key="sub3-5">
                  <Link to="/myleavebalance" onClick={()=>this.changeHeaderTitle('My Leave Balances')}>My Leave Balances</Link>
              </Menu.Item>
              : ''
              }

              {
                this.props.userPermissions.indexOf('view_leavetype') > -1 ? 
                <Menu.Item key="sub3-6">
                    <Link to="/leavetype" onClick={()=>this.changeHeaderTitle('Leave Types')}>Leave Type</Link>
                </Menu.Item>
                : ''
              }

              {
                this.props.userPermissions.indexOf('view_leavepolicy') > -1 ? 
                <Menu.Item key="sub3-7">
                    <Link to="/leavepolicy" onClick={()=>this.changeHeaderTitle('Leave Policies')}>Leave Policy</Link>
                </Menu.Item>
                : ''
              }

              {
                // this.props.userPermissions.indexOf('view_leavecalendar') > -1 ? 
                <Menu.Item key="sub3-8">
                    <Link to="/leavecalendar" onClick={()=>this.changeHeaderTitle('Leave Calendar')}>Leave Calendar</Link>
                </Menu.Item>
                // : ''
              }
            </SubMenu>
            : ''
            }
            
          </Menu>
        </Sider>:<div></div>

}
        
        <Layout>
          {
            this.props.isAuthenticated ?
          
          <Header style={{ background: '#fff', padding: 0 }} >
              
          <Row type="flex" >
          <Col span={8} offset={1}>
            <h2>{this.props.headerTitle}</h2>
          </Col>
          <Col span={7} offset={4}>
            
            <Menu
                theme="light"
                mode="horizontal"
                defaultSelectedKeys={['2']}
                style={{ lineHeight: '64px' }}
              >
                  <Menu.Item key="1">
                  <span>Welcome, <b>{ this.props.loggedInEmployee.firstName + ' ' +  this.props.loggedInEmployee.lastName }</b></span>
                  </Menu.Item>
              </Menu>
          </Col>
            <Col span={4}>
                <Menu
                  theme="dark"
                  mode="horizontal"
                  defaultSelectedKeys={['2']}
                  style={{ lineHeight: '64px' }}
                >
                  <Menu.Item key="2" >
                  <Popover placement="bottom" title="Notifications" content={content} trigger="click">
                    <Badge count={5}>
                        <a href="#" className="head-example" />
                    </Badge>
                  </Popover>
                  </Menu.Item>
                  <Menu.Item key="3" onClick={this.props.logout} >
                    Logout
                  </Menu.Item>
                  {/* <Menu.Item key="4" >
                    <span>Welcome, { this.props.loggedInEmployee.firstName + ' ' +  this.props.loggedInEmployee.lastName }</span>
                  </Menu.Item> */}
              </Menu>
            </Col>
          </Row>
          </Header>
          :
          <Header style={{ padding: 0 }} >
              
          <Row type="flex" >
            <Col span={4} push={0}>
              <div className="logo" >
                {/* <h2 style={{color: "white", margin: "12px"}}>FedHr</h2> */}
              </div>
            </Col> 
            <Col span={4}>
                <Menu
                theme="dark"
                mode="horizontal"
                defaultSelectedKeys={['2']}
                style={{ lineHeight: '64px' }}
              >
                  <Menu.Item key="1">
                    <Link to="/login">Login</Link> 
                  </Menu.Item>
              </Menu>
            </Col>
          </Row>
          </Header>
          }
          <Content style={{ margin: '0 16px' }}>
          {
            this.props.isAuthenticated ?
            <Breadcrumb style={{ margin: '16px 32px' }}>
              <Breadcrumb.Item>Dashboard</Breadcrumb.Item>
              <Breadcrumb.Item>Item</Breadcrumb.Item>
            </Breadcrumb>
            :
              <br/>
          }
            
            <div style={{ padding: 24, background: '#fff', minHeight: 360 }}>
                {
                  this.props.isAuthenticated ? 
                    (
                        <Switch>
                          <Route path="/" exact component={Dashboard} />
                          <Route path="/employee" exact component={Employee} />
                          <Route path="/employee/new" exact component={EmployeeCreate} />
                          <Route path="/employee/:employeeId" exact component={EmployeeCreate} />
                          <Route path="/country" exact component={Country} />
                          <Route path="/costcenter" exact component={CostCenter} />
                          <Route path="/education" exact component={Education} />
                          <Route path="/employmentstatus" exact component={EmploymentStatus} />
                          <Route path="/ethnicity" exact component={Ethnicity} />
                          <Route path="/jobcategory" exact component={JobCategory} />
                          <Route path="/jobtitle" exact component={JobTitle} />
                          <Route path="/language" exact component={Language} />
                          <Route path="/license" exact component={License} />
                          <Route path="/location" exact component={Location} />
                          <Route path="/membership" exact component={Membership} />
                          <Route path="/nationality" exact component={Nationality} />
                          <Route path="/paygrade" exact component={PayGrade} />
                          <Route path="/skill" exact component={Skill} />
                          <Route path="/subunit" exact component={SubUnit} />
                          <Route path="/user" exact component={User} />
                          <Route path="/workshift" exact component={WorkShift} />
                          <Route path="/leavetype" exact component={LeaveType} />
                          <Route path="/myleaverequest" exact component={MyLeaveRequest} />
                          <Route path="/leaverequests-for-approval" exact component={LeaveRequestsForApproval} />
                          <Route path="/leaverequest" exact component={LeaveRequest} />
                          <Route path="/leavepolicy" exact component={LeavePolicy} />
                          <Route path="/leavebalance" exact component={LeaveBalance} />
                          <Route path="/myleavebalance" exact component={MyLeaveBalance} />
                          <Route path="/leavecalendar" exact component={LeaveCalendar} />
                          <Route path="/department" exact component={Department} />
                          <Route path="/division" exact component={Division} />
                          <Route path="/holiday" exact component={Holiday} />
                          <Route path="/user-roles" exact component={Group} />
                          <Route path="/user-permissions" exact component={Permission} />
                          <Route path="/password-reset" exact component={PasswordReset} />
                        </Switch>
                    )
                    :
                    (
                        <Switch>
                          <Route path="/" exact component={Login} />
                          <Route path="/login/" exact component={Login} />
                          <Route path="/signup/" exact component={Signup} />
                          <Redirect to="/" />
                        </Switch>
                    )
                }
            </div>
          </Content>
          <Footer style={{ textAlign: 'center' }}>
             ©2019 TIA Hr
          </Footer>
        </Layout>
      </Layout>
      </Router>
    );
  }
}

const mapStateToProps = state => {
  return {
    isAuthenticated: state.token !== null,
    currentUser: state.currentUser,
    loggedInEmployee: state.loggedInEmployee,
    headerTitle: state.headerTitle,
    userPermissions: state.userPermissions,
    userContentTypes: state.userContentTypes
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onTryAutoSignup: () => dispatch(actions.authCheckState()),
    logout: () => dispatch(actions.logout()),
    changeHeaderTitle: (title) => dispatch(actions.changeHeaderTitle(title))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
